import axios from 'axios';

export const getAddresByCep = async ({ queryKey }) => {
	const [, cep] = queryKey;
	const url = `https://viacep.com.br/ws/${cep}/json/`;
	const response = await axios.get(url);
	return response.data;
};
